import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'

const DivTitle = styled.div`
	display: flex;
	cursor: pointer;
	width: 281px;
	height: 36px;
	padding: 0 12px;
	background-color: #f3f3f3;
	color: white;
	font-weight: 600;
	letter-spacing: .1px;
	background-image: linear-gradient(to bottom right, rgb(219,22,51), #961427);
	justify-content: space-between;
	align-items: center;
`

const P = styled.p`
	margin: 0;
`

const BrandsDiv = styled.div`
	margin-left: 48px;
`

const DivOptions = styled.div`
	display: flex;
	flex-direction: column;
	padding-right: 4px;
	overflow-y: auto;
	overflow-x: hidden;
	max-height: 500px;
`

export default function Plugin({ children, Icon, title, drawerOpen, setDrawerOpen, classes }) {
    const [isOpen, setIsOpen] = useState(true)

    useEffect(() => {
        if (drawerOpen) setIsOpen(true)
    }, [drawerOpen])

    return (
        <div>
            <DivTitle onClick={() => {
                if (!drawerOpen) setDrawerOpen(true)
                setIsOpen(!isOpen)
            }}
            >
                <Icon />
                <P>{title}</P>
                <FontAwesomeIcon icon={isOpen ? 'caret-up' : 'caret-down'} color="white" />
            </DivTitle>

            <BrandsDiv className={clsx({
                [classes.expand]: drawerOpen || isOpen,
                [classes.collapse]: !isOpen || !drawerOpen
            })}
            >
                <DivOptions>
                    {children}
                </DivOptions>
            </BrandsDiv>
        </div>
    )
}